<template>
  <div class="footer">
    <div class="help">
      <div class="logo">
        <img src="../../assets/images/公司logo.png" alt="杭州越璋文化传媒有限公司" />
        <div style="color: #FFF;">杭州越璋文化传媒有限公司</div>
      </div>
      <div class="cont">
        <div class="item" v-for="(item, index) in footList" :key="index">
          <div class="item-box">
            <span class="item_title">{{ item.name }}</span>
            <template v-for="(jtem, jndex) in item.children">
              <template v-if="item.isClick">
                <div class="item_child af" @click="go(jtem)" style="cursor: pointer" :key="index + '-' + jndex">
                  {{ jtem.name }}
                </div>
              </template>
              <template v-else>
                <div :key="index + '-' + jndex">
                  <i :class="jtem.icon"></i> <span style="padding-left: 10px">{{ jtem.name }}</span>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span class="name">Copyright @2025杭州越璋文化传媒有限公司</span>
      <a href="https://beian.miit.gov.cn/" class="bah af" style="cursor: pointer">浙ICP备2021038862号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footList: [
        {
          name: "解决方案",
          isClick: true,
          children: [
            { name: "小红书全域运营", href: "/solve", scrollTo: 'jjfa' },
            { name: "达人私域保ROI/CPA", href: "/solve", scrollTo: 'jjfa' },
            { name: "内容跨域整合营销", href: "/solve", scrollTo: 'dptnrzh' },
          ],
        },
        {
          name: "关于我们",
          isClick: true,
          children: [
            { name: '核心价值', href: "/about", scrollTo: 'hxln' },
            { name: '发展历程', href: "/about", scrollTo: 'fzlc' },
          ],
        },
        {
          name: "联系我们",
          isClick: false,
          children: [
            {
              name: "浙江省杭州市余杭区仓前街道龙潭路16号幢8层809室",
              href: "mailto://Biz@fintechgp.com",
              icon: 'el-icon-location'
            },
            { name: "13666648636", href: "mailto://Biz@fintechgp.com", icon: 'el-icon-phone' },
            { name: "katherine@qixidata.com", href: "mailto://Biz@fintechgp.com", icon: 'el-icon-message' },
          ],
        },
      ],
    };
  },
  methods: {
    go(item) {
      console.log(' this.$route.path', this.$route.path)
      if (this.$route.path === item.href) {
        this.$emit("scrollToPageEl", item.scrollTo);
      } else {
        this.$router.push({
          path: item.href,
          query: { scrollTo: item.scrollTo }
        });
      }

    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #999999;
  // text-decoration: underline !important;
}

a:hover {
  color: #E33333;
}

.af:hover {
  color: #E33333;
}

.footer {
  width: 100%;
  height: 340px;
  background-color: #111827;
  color: #8e9198;
}

.help {
  width: 1600px;
  height: 201px;
  border-bottom: 1px solid #9ba7c1;
  margin: 0 auto;
  //padding-top: 96px;
  max-width: 90%;
  display: flex;
  justify-content: center;


  //align-items: center;
}

.cont {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-start;
  //margin-left: 531px;
  height: 200px;
  align-items: flex-start;
  padding-top: 50px;
  margin-left: 76px;
}

.logo {
  flex: 0;
  display: flex;
  justify-content: center;
  padding-top: 50px;
  //align-items: center;
}

.logo img {
  width: 50px;
  height: 50px;
  background-size: 100% 100%;
}

.logo div {
  width: 300px;
  margin-bottom: 10px;
  font-size: x-large;
  font-weight: 600;
}

.item {
  // padding: 0.4rem 0 0.2rem;
  line-height: 30px;
  height: 30px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  //align-items: end;
  // text-align: end;
}

.item_title {
  line-height: 30px;
  color: white;
  margin-bottom: 20px;
  font-size: 22px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 550;
}

.item_child {
  line-height: 30px;
  margin-bottom: 0.2rem;
  color: #868d99;
}

.copyright {
  width: 1600px;
  padding: 0.2rem 0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  margin: 0 auto;
  padding-top: 55px;
  max-width: 1196px;
}

.bah {
  margin-left: 5px;
}

@media screen and (max-width: 768px) {
  .logo img {
    width: 4rem;
  }

  .item {
    // padding: 0.6rem 0 0.4rem;
    line-height: 0.3rem;
    font-size: 0.2rem;
  }

  .copyright {
    color: #999999;
    padding: 0.4rem 0;
    line-height: 0.4rem;
    font-size: 0.2rem;
    font-family: PingFang SC;
    font-weight: 500;
  }
}

@media screen and (max-width: 580px) {
  .cont {
    // padding: 0.2rem 0 0.4rem;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  .item {
    // padding: 0.4rem 0 0;
    line-height: 0.3rem;
    font-size: 0.2rem;
  }

  .copyright span,
  .copyright a {
    display: block;
  }
}
</style>
